module.exports = __webpack_public_path__ + "img/motivosity-logo.82a25ed0.png";